import './components';
import './store';
import './dn_bubble';
import SpNews from './sp-news';
import './carousel-in-banner'

$(() => {
  new SpNews();
});



// WEBPACK FOOTER //
// ./src/js/top/page.js